@if (topicStore.asArray(); as topics) {
  @if (topics.length > 0) {
    <p-pickList
      class="app-pick-list"
      [source]="sourceList()"
      [target]="targetList()"
      [dragdrop]="true"
      [responsive]="true"
      [showSourceControls]="showSourceControls"
      [showTargetControls]="showTargetControls"
      (onMoveToSource)="removeFromSelection($event)"
      (onMoveToTarget)="addToSelection($event)"
      (onMoveAllToSource)="removeFromSelection($event)"
      (onMoveAllToTarget)="addToSelection($event)"
      [sourceStyle]="{ height: '30rem' }"
      [targetStyle]="{ height: '30rem' }"
      breakpoint="1400px">
      <ng-template pTemplate="sourceHeader">
        <app-pick-list-header title="Themen" [count]="sourceList().length" />
      </ng-template>
      <ng-template pTemplate="targetHeader">
        <app-pick-list-header title="Auswahl" [count]="targetList().length" />
      </ng-template>
      <ng-template let-topic pTemplate="item">
        <div class="pl-row">
          <i class="fas fa-book-open pl-icon"></i>
          <span class="pl-name">{{ topic.title }}</span>
        </div>
      </ng-template>
      <ng-template pTemplate="emptymessagesource">
        <div class="pl-empty">Keine weiteren Einträge.</div>
      </ng-template>
      <ng-template pTemplate="emptyfiltermessagesource">
        <div class="pl-empty">Kein Eintrag passt zur Suche.</div>
      </ng-template>
      <ng-template pTemplate="emptymessagetarget">
        <div class="pl-empty">
          Noch nichts ausgewählt – per Doppelklick, Pfeil oder Ziehen
          übernehmen.
        </div>
      </ng-template>
      <ng-template pTemplate="emptyfiltermessagetarget">
        <div class="pl-empty">Kein Eintrag passt zur Suche.</div>
      </ng-template>
    </p-pickList>
  } @else {
    <app-alert styleClass="m-0 p-3" [canToggle]="false" severity="secondary">
      Keine Themen gefunden
    </app-alert>
  }
}
